"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueFilter = void 0;
const react_1 = __importDefault(require("react"));
const ramda_1 = require("ramda");
const filter_constants_1 = require("../../../filter.constants");
const filter_model_1 = require("../../../filter.model");
const filter_utils_1 = require("../../../filter.utils");
const inputs_1 = require("../../inputs");
const filter_row_component_1 = require("../filter-row.component");
const localization_1 = require("../../../../../../localization");
const ValueFilter = ({ firstRow, filter, onChangeField, onChangeOperator, onRemoveFilter, onUpdateFilter, onChangeConnector, operator, field, fieldSpecifier = null, value, connectorOperator, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    // do not change order of options
    // the constant `operatorOptions` relies on the order of options defined here
    const allOperatorOptions = [
        { label: t({ key: 'IS' }), value: filter_model_1.FilterOperator.Is },
        { label: t({ key: 'IS_NOT' }), value: filter_model_1.FilterOperator.IsNot },
        { label: t({ key: 'CONTAINS' }), value: filter_model_1.FilterOperator.Contains },
        { label: t({ key: 'NOT_CONTAIN' }), value: filter_model_1.FilterOperator.DoesNotContain },
        { label: t({ key: 'STARTS_WITH' }), value: filter_model_1.FilterOperator.StartsWith },
        { label: t({ key: 'ENDS_WITH' }), value: filter_model_1.FilterOperator.EndsWith },
    ];
    const operatorOptions = (0, filter_utils_1.isUuidField)(field, fieldSpecifier)
        ? allOperatorOptions.slice(0, 2)
        : filter_constants_1.BOOLEAN_FIELDS.includes(fieldSpecifier)
            ? allOperatorOptions.slice(0, 1)
            : allOperatorOptions;
    return (react_1.default.createElement(filter_row_component_1.FilterRow, { firstRow: firstRow, selectedFilterField: field, onChangeFilterField: onChangeField, operatorOptions: operatorOptions, selectedFilterOperator: operator, onChangeFilterOperator: onChangeOperator, fieldSpecifierInput: (0, inputs_1.isFieldSpecifierRequired)(field)
            ? react_1.default.createElement(inputs_1.FieldSpecifierInputDisplay, { field: field, onUpdateValue: (specifier) => {
                    if (filter_constants_1.BOOLEAN_FIELDS.includes(specifier)) {
                        onUpdateFilter((0, ramda_1.merge)(filter, { [filter_model_1.FilterOption.FieldSpecifier]: specifier, operator: filter_model_1.FilterOperator.Is }));
                    }
                    else {
                        onUpdateFilter((0, ramda_1.assoc)(filter_model_1.FilterOption.FieldSpecifier, specifier, filter));
                    }
                }, selected: filter.fieldSpecifier })
            : null, filterValueInput: react_1.default.createElement(inputs_1.ValueInputDisplay, { field: field, selected: value, onUpdateValue: (value) => onUpdateFilter((0, ramda_1.assoc)(filter_model_1.FilterOption.Value, value, filter)), filter: filter, fieldSpecifier: fieldSpecifier }), connectorOperator: connectorOperator, onChangeConnector: onChangeConnector, removeAdvancedFilter: onRemoveFilter }));
};
exports.ValueFilter = ValueFilter;
exports.default = exports.ValueFilter;
